import { get } from './get';
import { isFunction } from './isFunction';

export function getKey(input, pathGetter) {
  return isFunction(pathGetter) ? pathGetter(input) : get(input, pathGetter);
}
